import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaOptionList from './VaOptionList.vue'

export default withConfigTransport(VaOptionList)
